import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-card-quote',
  styleUrl: 'card-quote.css',
  shadow: true,
})
export class CardQuote {
  @Element() host : HTMLElement;

  @Prop() type : string;

  handleSlotChange = () => {
    if (this.host.classList.contains('b')) {
      let children = Array.from(this.host.children);
      let quote = children && children.find(item => item.classList.contains('quote'));
      if (children && quote) {
        this.host.shadowRoot.querySelector('.quote-container').appendChild(quote);
      }
    }
  }

  render() {
    return (
      <Host class={ this.type }>
        <div class="quote-container"></div>
        <slot onSlotchange={ this.handleSlotChange }></slot>
      </Host>
    );
  }

}
